import { render, staticRenderFns } from "./InboundDaysByCenter.vue?vue&type=template&id=74ea39b1&scoped=true"
import script from "./InboundDaysByCenter.vue?vue&type=script&lang=js"
export * from "./InboundDaysByCenter.vue?vue&type=script&lang=js"
import style0 from "./InboundDaysByCenter.vue?vue&type=style&index=0&id=74ea39b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ea39b1",
  null
  
)

export default component.exports